import { Helmet } from "react-helmet-async";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { T } from "@/components/T";

const faqs = [
  { q: "Is GenieBot really free?", a: "Yes. Core AI chat, 27+ tools, prompt studio, image generation, and games are all free. GenieBot Pro unlocks premium tools and higher limits for $8.99/mo." },
  { q: "What AI models does GenieBot use?", a: "GenieBot supports 10+ models including GPT, Gemini, and DeepSeek. Different tools use different models optimized for their specific task." },
  { q: "Do I need to install anything?", a: "No. GenieBot runs entirely in your browser. Sign up and start using any tool immediately." },
  { q: "Is my data secure?", a: "Yes. All data is encrypted at rest with AES-256. We don't sell your data or use it to train external models." },
  { q: "What's the difference between the GenieBot products?", a: "GenieBot is the main AI hub. The other products (coming soon) will serve business, global, and community use cases respectively." },
  { q: "Can I build my own chatbot?", a: "Yes. The Chatbot Builder lets you create custom AI chatbots with your own knowledge base, deploy them on your website, and share them publicly." },
  { q: "How do I cancel my subscription?", a: "You can cancel anytime from your Subscription Management page. No contracts, no cancellation fees." },
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export const LandingFAQ = () => (
  <section className="py-20 px-4" aria-labelledby="faq-heading">
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
    </Helmet>
    <div className="max-w-3xl mx-auto">
      <h2 id="faq-heading" className="text-3xl md:text-4xl font-bold text-center mb-3"><T>Frequently Asked Questions</T></h2>
      <p className="text-muted-foreground text-center mb-10"><T>Quick answers to common questions.</T></p>
      <Accordion type="single" collapsible className="space-y-2">
        {faqs.map((faq, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border border-border rounded-xl px-4 sm:px-5 data-[state=open]:bg-card">
            <AccordionTrigger className="text-left text-sm font-medium hover:no-underline py-4">
              <T>{faq.q}</T>
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground pb-4 leading-relaxed">
              <T>{faq.a}</T>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
